// extracted by mini-css-extract-plugin
export var bg = "main-module--bg--3e7c3";
export var title = "main-module--title--2bf46";